import { connect } from 'react-redux';
import { CommonActions } from '@react-navigation/native';
import { compose, withProps } from 'react-recompose';
import I18n from '../../lib/i18n';
import Navigation from '../../lib/navigation';
import MyWallet from './MyWallet';
import { premiumUsagesCurrentAmountSelector } from '../../modules/Usage/selectors';
import { currentSubscriptionPaymentAuthenticationsSelector } from '../../modules/Payment/selector';

const mapStateToProps = state => ({
  balance: premiumUsagesCurrentAmountSelector(state),
  hasUnauthenticatedPayment: !!currentSubscriptionPaymentAuthenticationsSelector(state).length,
});

const withMyWalletForPremiumProps = () => ({
  addMoneyButtonText: I18n.t('Dashboard.MyWalletForPremium.addMoney'),
  currentBalanceText: I18n.t('Dashboard.MyWalletForPremium.currentBalance'),
  infoTitleText: I18n.t('Dashboard.MyWalletForPremium.infoTitle'),
  infoContentText: I18n.t('Dashboard.MyWalletForPremium.infoContent'),
  goToAddMoneyPage: () => Navigation.dispatch(CommonActions.navigate({ name: 'addMoneyWithCreditCardForPremium' })),
  canAddMoneyToWallet: true,
});

export default compose(connect(mapStateToProps), withProps(withMyWalletForPremiumProps))(MyWallet);
